












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "select-brand-list": () =>
      import("@/components/app/admin/tenancy/selectBrandList.vue")
  }
})
export default class SelectBrandModal extends Vue {
  @Prop({ required: false, default: "" })
  public message!: string;
}
